















































import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import { OverviewLayoutITF } from '@/interfaces';
import FieldDefs from './FieldDefs';
import {new_curdate, endOfMonth} from '@/claesutils';
import {commitAddNotification} from '@/store/main/mutations';

interface AddWorkDayRec {
  begin: string;
  end: string;
}

interface CreateInvoicesRec {
  date: string;
}

@Component
export default class JobsOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
  public dialogAddWorkDay = false;
  public dialogCreateInvoices = false;
  public showReportCustomer = false;
  public showReportDriver = false;
  public showCreateInvoices = false;
  public recAddWorkDay: AddWorkDayRec = {begin: '', end: ''};
  public recCreateInvoices: CreateInvoicesRec = {date: ''};

  public startCreateInvoices() {
    this.recCreateInvoices.date = new_curdate();
    this.dialogCreateInvoices = true;
  }
  public async createInvoices() {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'createinvoices', {invoice_date: this.recCreateInvoices.date, filter: this.getFilterValues()});
    if (response) {
      const data: any = response.data;
      const msg = `Facturen gemaakt: ${data.job_invoices} Werk facturen voor ${data.total_jobs_notinvoiced} werken en ${data.project_invoices} ProjectWerk facturen voor ${data.total_projectjobs_notinvoiced} project werken.`;
      commitAddNotification(this.$store, {content: msg, color: 'success'});
      if (this.$refs.overview) {
        ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
      }
    }

  }
  public startAddWorkDay() {
    this.recAddWorkDay.begin = this.recAddWorkDay.end = new_curdate();
    this.dialogAddWorkDay = true;
  }
  public begin_date_changed() {
    if (this.recAddWorkDay.begin) {
      if (this.recAddWorkDay.end) {
        if (this.recAddWorkDay.end < this.recAddWorkDay.begin) {
          this.$set(this.recAddWorkDay, 'end', this.recAddWorkDay.begin);
        }
      } else {
        this.$set(this.recAddWorkDay, 'end', this.recAddWorkDay.begin);
      }
    }
  }
  public async executeAddWorkDay(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'addworkday', rec);
    if (this.$refs.overview) {
      ((this.$refs.overview as unknown) as OverviewLayoutITF).tableUpdateData(true);
    }
  }
  public async calcOverlap() {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'calcoverlap', {nr_of_days: 24});
    if (response) {
      const data: any = response.data;
      let msg = `Overlaps berekend: ${data.total_jobs} werken met ${data.overlaps} overlaps. ${data.changes} aanpassingen.`;
      if (data.mismatching_overlaps) {
        msg += ` ${data.mismatching_overlaps} rechtzettingen.`;
      }
      commitAddNotification(this.$store, {content: msg, color: 'success'});
    }
  }

  public async createReportCustomer() {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'createcustomerreport', {filter: this.getFilterValues()});
    if (response) {
      const data: any = response.data;
      const ref: any = this.$refs.overview;
      ref.previewUrl(data.url);
    }
  }

  public async createReportDriver() {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + 'createdriverreport', {filter: this.getFilterValues()});
    if (response) {
      const data: any = response.data;
      const ref: any = this.$refs.overview;
      ref.previewUrl(data.url);
    }
  }

  public handleTableLoaded(overview) {
    const has2Dates = (overview.filters.begin_timestamp_date_ge && overview.filters.begin_timestamp_date_le);
    const hasStartDate = overview.filters.begin_timestamp_date_ge;
    this.showReportCustomer = hasStartDate && (overview.tableTotal < 1000);
    this.showReportDriver = (has2Dates && (overview.filters.driver_id > 0)) && (overview.tableTotal > 0);
    this.showCreateInvoices = (has2Dates /*&& (overview.filters.customer_id > 0)*/) && (overview.tableTotal > 0);
  }

  public handleFilterChanged(filters, filter) {
    // console.log('handleFilterChanged', filter, filters, filter === 'begin_timestamp_date_ge', !filters.begin_timestamp_le, (filter === 'begin_timestamp_date_ge') && filters.begin_timestamp_date_ge && !filters.begin_timestamp_date_le);
    // if ((filter === 'begin_timestamp_date_ge') && filters.begin_timestamp_date_ge && (!filters.begin_timestamp_date_le || (endOfMonth(filters.begin_timestamp_date_le) == filters.begin_timestamp_date_le))) {
    //   filters.begin_timestamp_date_le = endOfMonth(filters.begin_timestamp_date_ge);
    // }
  }

}
